module.exports = __webpack_public_path__ + "img/tpm-welcome.ae20cee7.png";